import { UPDATE_POLICY } from "../actions/types"

const initialState = {
    policyInfo: {}
}

const policyReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_POLICY:
            return Object.assign({}, state, {
                policyInfo: action.payload,
            });
        default:
            return state
    }
}

export default policyReducer;
